import { userOptionsStore } from '~/shared/api'

/**
 * Подключён ли депозитный баланс у таксопарка пользователя (приходит в /users/me при входе).
 */
export const useDepositBalance = () => {
  const isDepositBalanceEnabled = userOptionsStore.depositBalanceEnabled

  return { isDepositBalanceEnabled }
}
